import { Ias } from "./ias"
import { q } from "../../helper/q"
import { catalogSorting } from "./sorting"
import { catalogFilter } from "./filter"

export const catalogInit = () => {
  const containers = q(".productsGroup")
  if (containers) {
    const ias = new Ias(containers)
    if (q(".pageMoreNav")) {
      ias.init()
    }
    catalogSorting()
    catalogFilter()
  }
}
